<template>
  <div class="beneficios-boxes">
    <div class="img">
      <!-- <img src="@/assets/images/benefit-1-job.png" v-if="$route.name == 'job'" /> -->
      <img src="@/assets/images/benefit-1.png" v-if="$route.name == 'home'" />
      <img src="@/assets/images/benefit-1-hover.png" class="img-hover" v-if="$route.name == 'home'" />
    </div>

    <div class="img">
      <!-- <img src="@/assets/images/benefit-2-job.png" v-if="$route.name == 'job'" /> -->
      <img src="@/assets/images/benefit-2.png" v-if="$route.name == 'home'" />
      <img src="@/assets/images/benefit-2-hover.png" class="img-hover" v-if="$route.name == 'home'" />
    </div>

    <div class="img">
      <!-- <img src="@/assets/images/benefit-3-job.png" v-if="$route.name == 'job'" /> -->
      <img src="@/assets/images/benefit-3.png" v-if="$route.name == 'home'" />
      <img src="@/assets/images/benefit-3-hover.png" class="img-hover" v-if="$route.name == 'home'" />
    </div>

    <div class="img">
      <!-- <img src="@/assets/images/benefit-4-job.png" v-if="$route.name == 'job'" /> -->
      <img src="@/assets/images/benefit-4.png" v-if="$route.name == 'home'" />
      <img src="@/assets/images/benefit-4-hover.png" class="img-hover" v-if="$route.name == 'home'" />
    </div>

    <div class="img">
      <!-- <img src="@/assets/images/benefit-5-job.png" v-if="$route.name == 'job'" /> -->
      <img src="@/assets/images/benefit-5.png" v-if="$route.name == 'home'" />
      <img src="@/assets/images/benefit-5-hover.png" class="img-hover" v-if="$route.name == 'home'" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Benefits'
  }
</script>

<style lang="scss" scoped>
.beneficios-boxes{
  display: flex;
  flex-wrap: wrap;
  gap: 30px;
  justify-content: center;

  @media (max-width: 600px){
    overflow: auto;
    flex-wrap: nowrap;
    justify-content: flex-start;
  }

  .img{
    max-width: 180px;
    position: relative;
    transition: transform 0.2s ease-in-out;

    &:hover{
      transform: translateY(-10px);

      .img-hover{
        opacity: 1;
      }
    }
    
    img{
      width: 100%;
    }

    .img-hover{
      position: absolute;
      inset: 0;
      opacity: 0;
      transition: opacity 0.2s ease-in-out;
    }
  }

}
</style>